module.exports = __webpack_public_path__ + "static/pic01-c01924a87192046754d479b91f2c6d83.jpg";